
export function dispatchAction(actionName, params={}, data=null, error=null) {
    return {
        type: actionName,
        payload: {
            params,
            data
        },
        error
    };
}